<template>
  <div class="min-h-screen bg-gradient-to-b from-[#0f172a] via-[#1e293b] to-[#0f172a] dark:from-[#0c0f1a] dark:via-[#1e293b] dark:to-[#0c0f1a] overflow-x-hidden">

     <button
      type="button"
      data-mdb-ripple="true"
      data-mdb-ripple-color="light"
      @click="backToTop"
      class="inline-block z-10 p-3 hover:scale-105 transition-all  bg-yellow-400 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover: bg-yellow-400 hover:shadow-lg focus: bg-yellow-400  focus:shadow-lg focus:outline-none focus:ring-0 active: bg-yellow-400  active:shadow-lg transition duration-150 ease-in-out bottom-5 right-5"
      id="btn-back-to-top"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        class="w-4 h-4"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path
          fill="currentColor"
          d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
        ></path>
      </svg>
    </button>

      <!-- ================= NAVBAR ================= -->
    <Popover
      :class="[
        'fixed w-full top-0 left-0 z-50 transition-all duration-300',
        scrolled
          ? 'bg-[#0f172a]/90 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      ]"
    >
      <div class="max-w-7xl mx-auto px-4 sm:px-6">
        <div class="flex items-center justify-between py-4">

          <!-- Logo -->
          <router-link to="/" class="flex items-center gap-2">
            <img class="h-9 w-auto" src="../assets/logo11.png" alt="oillead" />
            <div class="leading-tight">
              <div class="text-sm font-extrabold text-white">
                OIL<span class="text-yellow-400">L</span>EAD
              </div>
              <div class="text-xs font-bold tracking-wide text-yellow-400">
                SERVICES
              </div>
            </div>
          </router-link>

          <!-- Desktop Nav -->
          <PopoverGroup class="hidden lg:flex items-center gap-10">
            <router-link to="/" class="nav-link">HOME</router-link>
            <router-link to="/about" class="nav-link">ABOUT US</router-link>
            <router-link to="/services"  class="nav-link">SERVICES</router-link>
            <router-link to="/projects"  class="nav-link">PROJECTS</router-link>
            <router-link to="/contact"  class="nav-link">CONTACT US</router-link>
          </PopoverGroup>

          <!-- Mobile Button -->
          <div class="lg:hidden">
            <PopoverButton
              class="rounded-md p-2 text-white hover:bg-white/10 transition"
            >
              ☰
            </PopoverButton>
          </div>
        </div>
      </div>

      <!-- ================= MOBILE MENU ================= -->
      <transition
        enter-active-class="duration-200 ease-out"
        enter-from-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="duration-150 ease-in"
        leave-from-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <PopoverPanel
          v-slot="{ close }"
          focus
          class="absolute z-50 top-0 inset-x-0 p-4 transform origin-top-right lg:hidden"
        >
          <div class="rounded-2xl shadow-2xl
                      bg-[#0f172a]/95 backdrop-blur-xl
                      border border-white/10">

            <div class="flex items-center justify-between px-6 py-5 border-b border-white/10">


                <div class="text-sm flex gap-2 font-bold text-white" >
                  <PopoverButton
                    class="flex items-center outline-none ring-0 focus:outline-none focus:ring-0 active:ring-0 border-0"
                    >
                    <img class="h-8 w-auto sm:h-10" src="../assets/logo11.png" alt="" />
                    </PopoverButton>
                   <div class="leading-tight">
                        <div class="text-sm font-extrabold text-white">
                            OIL<span class="text-yellow-400">L</span>EAD
                        </div>
                        <div class="text-xs font-bold tracking-wide text-yellow-400">
                            SERVICES
                        </div>
                    </div>
                </div>


              

              <PopoverButton
                class="rounded-md p-2 text-white hover:bg-white/10 transition"
              >
                ✕
              </PopoverButton>
            </div>

             <div class="px-6 py-6 flex flex-col items-center text-center gap-6">
                <router-link to="/" class="nav-link" @click="close">HOME</router-link>
                <router-link to="/about" class="nav-link" @click="close">ABOUT US</router-link>
                <router-link to="/services" class="nav-link" @click="close">SERVICES</router-link>
                <router-link to="/projects" class="nav-link" @click="close">PROJECTS</router-link>
                <router-link to="/contact" class="nav-link" @click="close">CONTACT US</router-link>
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>

    <!-- Hero Section -->
    <section
      id="home"
      class="relative isolate overflow-hidden bg-gradient-to-b from-slate-950 to-slate-900 py-24 sm:py-32 pt-32"
    >
      <div class="absolute inset-0 -z-10">
        <div class="absolute -top-40 right-0 -z-10 opacity-20">
          <div
            class="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-blue-500 via-blue-400 to-yellow-300 blur-3xl"
            :style="{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }"
          />
        </div>
      </div>

      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto lg:mx-0">
          <h1 class="text-4xl sm:text-6xl font-extrabold tracking-tight text-white mb-6">
            Our Services
          </h1>
          <p class="text-xl leading-8 text-gray-300">
           Oillead Integrated Services Ventures Limited (OLS) offer comprehensive engineering solutions spanning from feasibility studies and front-end 
           engineering design through detailed engineering, procurement, fabrication, and installation support 
           across onshore and offshore facilities.
          </p>
        </div>
      </div>
    </section>

    <!-- Services Grid -->
    <section id="services" class="relative py-24 sm:py-32">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="text-center mb-16">
          <h2 class="text-4xl font-bold text-white mb-4">Engineering Excellence</h2>
          <p class="text-gray-400 max-w-2xl mx-auto">
            Delivering innovative solutions across all phases of your project
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <ServiceCard
            v-for="(service, index) in serviceCards"
            :key="index"
            :title="service.title"
            :scrollname="service.scrollname"
            :description="service.description"
            :highlights="service.highlights"
            :index="index"
          />
        </div>
      </div>
    </section>

    <!-- Detailed Services -->
    <section
      v-for="(service, index) in detailedServices"
      :key="index"
      :id="service.id"
      :class="['relative py-24 sm:py-32 overflow-hidden',service.scroll]">
      <div class="absolute left-1/2 -translate-x-1/2 -top-32 -z-10 opacity-20">
        <div
          class="aspect-[1100/700] w-[72rem] bg-gradient-to-tr from-blue-600 via-blue-400 to-yellow-300 blur-3xl"
          :style="{ clipPath: 'polygon(60% 10%, 100% 30%, 90% 80%, 40% 100%, 0% 70%, 10% 20%)' }"
        />
      </div>
      
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div :class="['grid lg:grid-cols-2 gap-12 items-center', service.imagePosition === 'left' ? 'lg:auto-cols-fr' : '']">


                  <!-- Left Image -->
          <div v-if="service.imagePosition === 'left'" class="relative h-96 lg:h-full rounded-2xl overflow-hidden group" >
            <img
              :src="service.imageUrl || '/placeholder.jpg'"
              :alt="service.title"
              class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div class="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
          </div>

          <!-- Content -->
          <div>
            <h2 class="text-2xl sm:text-4xl font-bold text-white mb-6">{{ service.title }}</h2>
            <p class="text-lg text-gray-300 mb-8 leading-relaxed">{{ service.description }}</p>

            <div class="space-y-8">
              <div v-for="(capability, i) in service.capabilities" :key="i">
                <h3 class="text-xl font-semibold text-accent mb-3"  :style="{ color: '#facc15' }">{{ capability.heading }}</h3>
                <ul class="space-y-2">
                  <li v-for="(item, j) in capability.items" :key="j" class="flex items-start gap-3 text-gray-300">
                    <span class="text-accent font-bold mt-1"  :style="{ color: '#facc15' }">→</span>
                    <span>{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

                    <!-- Right Image -->
            <div
              v-if="service.imagePosition === 'right'"
              class="relative h-96 lg:h-full rounded-2xl overflow-hidden group"
            >
              <img
                :src="service.imageUrl || '/placeholder.jpg'"
                :alt="service.title"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div class="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>

        </div>
      </div>
    </section>

    <!-- CTA Section -->

     <section id="contact" class="relative py-28 bg-[#0f172a] ">
    

      <div class="max-w-2xl mx-auto text-center px-6">
        <h2 class="text-4xl font-bold text-white mb-6">
          Ready to Transform Your Project?
        </h2>
        <p class="text-xl text-gray-300 mb-10">
      Let's discuss how OLS can deliver engineering excellence for your next challenge.
        </p>

        <router-link to="/contact"
          class="inline-flex items-center gap-2 bg-yellow-400 font-bold py-4 px-10 rounded-xl text-black shadow-lg hover:bg-yellow-400 hover:scale-105 transition-all">
          Get in Touch →
        </router-link>

      </div>
    </section>

      <!-- ================= FOOTER ================= -->
    <footer class="bg-slate-950 border-t border-slate-800 py-10 text-center text-gray-400">
      © 2026 OILLEAD SERVICES. All rights reserved.
    </footer>

  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from "@headlessui/vue"

import ServiceCard from "./ServiceCard.vue"

import project3 from "../assets/detailedengineering.jpg"
import project8 from "../assets/construction9.jpg"
import project7 from "../assets/construction.jpg"
import ourservices12 from "../assets/ourservices12.jpg"


/* ================= SCROLL NAVBAR ================= */

const scrolled = ref(false)

const handleScroll = () => {
  scrolled.value = window.scrollY > 50
}

     // your arrow scroll function
      function scrollFunction() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "block";
      } else {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "none";
      }
    }

    // your arrow scroll function
    function backToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }

onMounted(() => {
      // navabar scroll
      window.addEventListener("scroll", handleScroll);

      // your arrow onscroll
      window.onscroll = function () {
        scrollFunction();
      };
    });

    onUnmounted(() => {
      //navbar scroll
      window.removeEventListener("scroll", handleScroll);

      // cleanup arrow scroll
      window.onscroll = null;
    });


/* ================= SERVICE CARDS ================= */

const serviceCards = [
  {
    title: "FEED & Detailed Engineering",
    scrollname: ".feedanddetailedengineering",
    description:
      "Comprehensive engineering solutions for onshore and offshore facilities with multi-discipline expertise.",
    highlights: [
      "Static and dynamic analysis",
      "Compliance with international standards",
      "Facility layout optimization",
      "Operability studies",
    ],
  },
  {
    title: "Lifting & Installation Engineering",
    scrollname:".liftingandinstallationengineering",
    description:
      "Advanced solutions ensuring structural integrity and operational safety in challenging offshore environments.",
    highlights: [
      "Structural lifting analysis",
      "Manufacturing design",
      "Fabrication & transportation",
      "Deployment & ballast planning",
    ],
  },
  {
    title: "Procurement & Construction",
    scrollname: ".procurementandconstruction",
    description:
      "End-to-end procurement and construction solutions from concept through installation and commissioning.",
    highlights: [
      "Strategic vendor relationships",
      "Heavy lift & installation",
      "Fabrication support",
      "Pre-commissioning & commissioning",
    ],
  },
  {
    title: "Battery Energy Storage Systems",
    scrollname: ".batteryenergystoragesystems",
    description:
      "Innovative ESS solutions reducing operational costs and improving power quality for remote operations.",
    highlights: [
      "Reduce diesel usage by 40-80%",
      "Remote monitoring & diagnostics",
      "Scalable from 100kWh to multi-MWh",
      "Sustainable community solutions",
    ],
  },
]


/* ================= DETAILED SERVICES ================= */

const detailedServices = [
  {
    id: "feed",
    title: "FEED & Detailed Engineering",
    scroll: "feedanddetailedengineering",
    description:
      "OLS provides detailed engineering solutions for onshore & offshore facilities and floating production systems.",
    capabilities: [
      {
        heading: "Design & Analysis",
        items: [
          "Development of multi-discipline Engineering deliverables for onshore and offshore floating structures.",
          "Static and dynamic analysis to evaluate line tensions, anchor holding capacity, and vessel motions.",
          "Compliance with international standards (ASME, API, BS, EUROCODES, ISO).",
          "Conceptual studies, specification, requirement developments.",
        ],
      },
      {
        heading: "Facility Layout Optimization",
        items: [
          "Design of optimal process facility layout configurations.",
          "Integration of environmental data (wind, wave, current).",
          "Sensitivity studies for extreme weather scenarios.",
        ],
      },
      {
        heading: "Installation Engineering",
        items: [
          "Operability studies for onshore and offshore deployment.",
          "Vessel heading and anchor pattern optimization.",
          "Development of installation procedures and plans.",
        ],
      },
    ],
    imagePosition: "right",
    imageUrl: project3,
  },

  {
    id: "lifting",
    title: "Lifting & Installation Engineering",
    scroll: "liftingandinstallationengineering",
    description:
      "Advanced solutions ensuring structural integrity, safety, and cost efficiency.",
    capabilities: [
      {
        heading: "Structural Lifting Analysis",
        items: [
          "Calculation of lifting points and padeye design.",
          "Verification of load paths during lifting.",
          "Compliance with international standards (API, DNV).",
        ],
      },
      {
        heading: "Manufacturing Design",
        items: [
          "Design of manufacturing processes.",
          "Modular manufacturing and installation plan.",
        ],
      },
      {
        heading: "Deployment & Transportation",
        items: [
          "Dynamic positioning studies.",
          "Ballast planning and motion analysis.",
        ],
      },
    ],
    imagePosition: "left",
    imageUrl: project8,
  },

  {
    id: "procurement",
    title: "Procurement and Construction",
    scroll: "procurementandconstruction",
    description:
      "OLS delivers end-to-end procurement and construction solutions for onshore and offshore assets.",
    capabilities: [
      {
        heading: "Procurement",
        items: [
          "Vendor relationships across Asia and Europe.",
          "End-to-end procurement strategy.",
          "OEM identification and delivery.",
        ],
      },
      {
        heading: "Construction",
        items: [
          "Heavy lift and installation",
          "Fabrication and installation",
          "Pre-commissioning",
          "Commissioning",
        ],
      },
      {
        heading: "Installation Engineering",
        items: [
          "Lifting sequences and rigging design.",
          "Operations and maintenance planning.",
        ],
      },
    ],
    imagePosition: "right",
    imageUrl: project7,
  },

  {
    id: "BESS",
    title: "Battery Energy Storage Systems",
    scroll: "batteryenergystoragesystems",
    description:
      "Our ESS and hybrid solutions introduce stable energy that reduces reliance on thermal generators.",
    capabilities: [
      {
        heading: "Why BESS Matters",
        items: [
          "Reduces diesel generator OPEX",
          "Simplifies fuel logistics",
          "Automated self-balancing operations",
          "Improves power quality",
        ],
      },
      {
        heading: "Benefits",
        items: [
          "Remote monitoring",
          "Commissioning support",
          "Sustainable CSR solutions",
          "High-temperature chemistries",
        ],
      },
      {
        heading: "Scalability",
        items: [
          "100kWh to multi-MWh systems",
          "Configured per load requirements",
          "Minimal moving parts",
          "Remote diagnostics",
        ],
      },
    ],
    imagePosition: "left",
    imageUrl: ourservices12,
  },
]


</script>

<style scoped>
.nav-link {
  font-size: 0.875rem;        /* text-sm */
  font-weight: 600;           /* font-semibold */
  letter-spacing: 0.05em;     /* tracking-wide */
  color: #ffffff;             /* text-white */
  cursor: pointer;            /* cursor-pointer */
  transition-property: color; /* transition-colors */
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
}

.nav-link:hover {
  color: #facc15; /* hover:text-yellow-400 */
}
</style>